import { render, staticRenderFns } from "./SM-Role-Selectbox.vue?vue&type=template&id=28758ba0"
import script from "./SM-Role-Selectbox.vue?vue&type=script&lang=js"
export * from "./SM-Role-Selectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports